import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReviewComponent} from './review.component';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {ReviewSummaryComponent} from './review-summary/review-summary.component';
import {FirstReviewComponent} from './first-review/first-review.component';
import {WriteReviewComponent} from './write-review/write-review.component';
import {NgbProgressbarModule} from '@ng-bootstrap/ng-bootstrap';
import {MediaModule} from '@spartacus/storefront';
import {ReviewPreviewComponent} from './review-preview/review-preview.component';
import {DcpPaginationModule} from '@app/shared/dcp-pagination/dcp-pagination.module';
import {
  WriteReviewDialogComponent
} from '@app/product/details/review/write-review/write-review-dialog/write-review-dialog.component';
import {LimitedTextModule} from '@app/shared/limited-text/limited-text.module';
import {StarRatingComponent} from './star-rating/star-rating.component';
import {ReviewAnswersComponent} from './review-answers/review-answers.component';
import {LimitedHtmlModule} from '@app/shared/limited-html/limited-html.module';
import {A11yModule} from '@angular/cdk/a11y';
import {AutofocusModule} from '@app/directives/autofocus/autofocus.module';

@NgModule({
  declarations: [
    ReviewComponent,
    ReviewSummaryComponent,
    FirstReviewComponent,
    WriteReviewComponent,
    ReviewPreviewComponent,
    WriteReviewDialogComponent,
    StarRatingComponent,
    ReviewAnswersComponent
  ],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductViewComponent: {
          component: ReviewComponent
        }
      }
    }),
    I18nModule,
    NgbProgressbarModule,
    MediaModule,
    DcpPaginationModule,
    LimitedTextModule,
    LimitedHtmlModule,
    A11yModule,
    AutofocusModule,
  ],
  exports: [
    ReviewComponent,
    ReviewSummaryComponent,
    FirstReviewComponent,
    WriteReviewComponent,
    StarRatingComponent,
    WriteReviewDialogComponent,
  ]
})
export class ReviewModule {
}
